<template>
  <div
    v-if="visivel"
    ref="tooltipModal"
    class="tooltip-modal"
    :style="{ top: `${posicao?.y ?? 0}px`, left: `${posicao?.x ?? 0}px` }"
    role="dialog"
    aria-modal="false"
  >
    <div v-for="campo in campos" :key="campo.titulo" class="tooltip-modal-item">
      <div class="tooltip-modal-header">
        {{ campo.titulo }}
      </div>
      <div class="tooltip-modal-body">
        {{ campo.valor == null || campo.valor === '' ? '-' : campo.valor }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visivel: { type: Boolean, default: false },
    campos: {
      type: Array,
      default: () => [],
      validator: (value) => Array.isArray(value) && value.every((item) => 'titulo' in item && 'valor' in item),
    },
    posicao: {
      type: Object,
      default: () => ({ x: 0, y: 0 }),
    },
  },
  emits: ['fechar'],
  mounted() {
    document.addEventListener('mousedown', this.aoClicarFora);
  },
  beforeUnmount() {
    document.removeEventListener('mousedown', this.aoClicarFora);
  },
  methods: {
    aoClicarFora(evento) {
      if (!this.visivel) return;
      if (this.$refs.tooltipModal?.contains(evento.target)) return;
      this.$emit('fechar');
    },
  },
};
</script>

<style scoped>
.tooltip-modal {
  position: fixed;
  z-index: 1080;
  min-width: 180px;
  max-width: 280px;
  padding: 0.5rem 0.75rem;
  border-radius: 0.5rem;
  border: 1px solid #343a40;
  background: #212529;
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.35);
}

.tooltip-modal-item + .tooltip-modal-item {
  margin-top: 0.5rem;
}

.tooltip-modal-header {
  font-size: 0.75rem;
  font-weight: 600;
  color: #ced4da;
}

.tooltip-modal-body {
  font-size: 0.875rem;
  font-weight: 500;
  color: #ffffff;
  margin-top: 0.15rem;
  word-break: break-word;
}
</style>
